module.exports = __webpack_public_path__ + "img/reincarnated head of hieda.f6aa1df3.png";